module.exports = __webpack_public_path__ + "static/amazonas-f355150dfa0d280096f3121b2e3d629a.jpeg";